import './Hero.css';

import heroPhoto from '../../assets/hero-contract.jpg';

const STATS = [
    { num: '3×', label: 'more relevant roles surfaced vs. browsing job boards alone' },
    { num: '68%', label: 'of users land interviews within their first month' },
    { num: '12k+', label: 'roles matched using AI, market data, and network signals' },
    { num: '40%', label: 'less time spent on applications that go nowhere' },
    { num: '4.8★', label: 'average rating from job seekers using Numus' },
];

function Hero() {
    return (
        <section className="al-section al-hero" id="home">
            <div className="al-shell al-hero-stack">
                <div className="al-hero-panel">
                    <div className="al-hero-copy">
                        <h1 className="al-display">
                            <span className="al-em">Find</span> Your Next Job Faster
                        </h1>
                        <p className="al-lead">
                            Numus is your AI job search assistant. It combines market data and your
                            professional network to surface better opportunities — and help you land them.
                        </p>
                        <div className="al-hero-actions">
                            <a
                                className="al-btn al-btn--dark"
                                href="https://chromewebstore.google.com/category/extensions"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Get Started
                            </a>
                            <a className="al-btn al-btn--outline" href="#how-it-works">How It Works</a>
                        </div>
                        <div className="al-rating">
                            <p className="al-semi">Trusted by job seekers</p>
                            <p>Built for people who want a smarter search, not another endless scroll.</p>
                        </div>
                    </div>
                    <div className="al-hero-visual" aria-hidden="true">
                        <div className="al-hero-frame al-hero-frame--outer" />
                        <div className="al-hero-frame al-hero-frame--inner" />
                        <div className="al-hero-photo">
                            <img src={heroPhoto} alt="" />
                        </div>
                        <span className="al-pill al-pill--a">Smarter matches.</span>
                        <span className="al-pill al-pill--b">Network insights.</span>
                        <span className="al-pill al-pill--c">Faster offers.</span>
                    </div>
                </div>
                <div className="al-stats">
                    {STATS.map((stat) => (
                        <div className="al-stat" key={stat.num}>
                            <p className="al-stat-num">{stat.num}</p>
                            <p className="al-stat-label">{stat.label}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default Hero;
